import { render, staticRenderFns } from "./AuthButton.vue?vue&type=template&id=e1f080c4&scoped=true"
import script from "./AuthButton.vue?vue&type=script&lang=js"
export * from "./AuthButton.vue?vue&type=script&lang=js"
import style0 from "./AuthButton.vue?vue&type=style&index=0&id=e1f080c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f080c4",
  null
  
)

export default component.exports